const URL = {
  TAG_LIST: 'tag',
  TAG_CREATE: 'tag',
  TAG_UPDATE: 'tag/{id}',
  TAG_DELETE: 'tag/{id}',
}

export default URL
